import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #00000050;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 5rem;
  overflow: visible;
`

export const Container = styled.div`
  width: 56rem;
  max-height: 90vh;
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 1.25rem;
  background-color: ${Tokens.ColorWhite};
  border-radius: ${Tokens.RadiusInput};
  overflow-y: auto;
  overflow-x: visible;
  position: relative;
`

export const AddThemeOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #00000050;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: visible;
`

export const AddThemeContainer = styled.div`
  width: 32rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 1.5rem;
  background-color: ${Tokens.ColorWhite};
  border-radius: ${Tokens.RadiusInput};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: visible;
  position: relative;
`

export const KeyMessageLabel = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${Tokens.ColorTextSecondary};
  margin: 0;
`

export const KeyMessageTag = styled.span`
  background-color: ${Tokens.ColorUIInfoLight};
  color: ${Tokens.ColorUIInfoDim};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
`

export const KeyMessageText = styled.span``

export const KeyMessageDeleteButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${Tokens.ColorUIDangerDim};
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
`

export const ModalTitle = styled.h3`
  margin: 0;
  text-align: center;
  flex: 1;
`

export const ModalDescription = styled.p`
  text-align: center;
  color: ${Tokens.ColorTextSecondary};
  margin: 0;
`

export const WarningText = styled.span`
  font-size: 14px;
  color: #856404;
  font-weight: 500;
`

export const SectionTitle = styled.h4<{ $disabled?: boolean }>`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.$disabled ? Tokens.ColorTextTertiary : Tokens.ColorTextPrimary)};
  margin: 0;
`

export const SectionLabel = styled.span<{ $disabled?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.$disabled ? Tokens.ColorTextTertiary : Tokens.ColorTextSecondary)};
`

export const EmptyStateText = styled.p`
  color: ${Tokens.ColorTextTertiary};
  font-size: 14px;
  text-align: center;
  margin: 0;
`

export const ThemeGroupLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${Tokens.ColorTextSecondary};
`

export const ThemeTag = styled.span`
  background-color: ${Tokens.ColorUIWarnLight};
  color: ${Tokens.ColorTextPrimary};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
`

export const ThemeTagText = styled.span``

export const ThemeTagDeleteButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${Tokens.ColorUIDangerDim};
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
`

export const WarningBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fff3cd;
  border-radius: 6px;
  border: 1px solid #ffeaa7;
  margin-bottom: 8px;
`

export const ThemeFormContainer = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 8px;
  padding: 16px;
  background-color: ${(props) => (props.$disabled ? '#f5f5f5' : '#f8f9fa')};
  border-radius: 8px;
  border: 1px solid ${(props) => (props.$disabled ? '#e0e0e0' : Tokens.ColorBorder)};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
`

export const SpokespersonTag = styled.span`
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-color: #1976d2;
`
